module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_botellas.47be6ae5.png";